<template>
  <v-container>
    <v-row
      align="center"
      justify="center"

    >
      <v-col md="6">
        <v-alert
          v-model="showNotice"
          :type="notificationType"
          transition="scale-transition"
        >
          {{ noticeMessage }}
        </v-alert>
      </v-col>
    </v-row>
    <v-row
      align="center"
      justify="center"

    >
      <v-col md="6">
        <v-toolbar
          color="primary"
          dark
        >
          <v-toolbar-title class="ml-0 pl-3">Reset Password</v-toolbar-title>
        </v-toolbar>
        <v-card>
          <v-card-title>
            <v-col class="text-md-center" >
              <h3 class="text-md-center">Check your email for a confirmation code and enter details below</h3>
            </v-col>
          </v-card-title>
          <v-card-text>
            <v-form
              ref="login-form"
              lazy-validation>
              <v-text-field
                v-model="confirmation_code"
                label="Confirmation Code"
                v-validate="'required'"
                data-vv-name="confirmation_code"
                :error-messages="errors.collect('confirmation_code')"
                required />
             <v-text-field
                v-model="password"
                label="New Password"
                type="password"
                v-validate="'required'"
                data-vv-name="password"
                :error-messages="errors.collect('password')"
                required />
              <v-text-field
                v-model="password_confirmation"
                label="New Password Confirmation"
                type="password"
                v-validate="'required'"
                data-vv-name="password_confirmation"
                :error-messages="errors.collect('password_confirmation')"
                required />
              <v-btn
                color="info"
                @click.prevent="resetPassword"
                type="submit">Reset Password</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-footer
      :fixed="fixed"
      app
    >
      <v-col class="text-md-center" >
        <span v-html="$copyright"></span>
      </v-col>
    </v-footer>
  </v-container>
</template>

<script>
// TODO TOMORROW - TEST ERROR CASE
export default {
  data: function () {
    return {
      name: '',
      password: null,
      password_confirmation: null,
      confirmation_code: null,
      notificationType: 'error',
      showNotice: false,
      noticeMessage: null,
      fixed: false
    }
  },
  methods: {
    clearError: function () {
      this.notificationType = 'error'
      this.showNotice = false
      this.noticeMessage = null
    },
    validateAndSubmit () {
      this.clearError()
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          if (this.password !== this.password_confirmation) {
            this.showNotice = true
            this.noticeMessage = 'Password confirmation does not match'
          } else {
            this.resetPassword()
          }
        }
      })
    },
    resetPassword () {
      this.clearError()
      this.$store.dispatch('confirmPassword', { username: this.$route.query.username, code: this.confirmation_code, newPassword: this.password })
        .then(() => {
          this.notificationType = 'success'
          this.noticeMessage = 'Successfully Changed Password. Login with new password'
          this.showNotice = true
        }).then(() => {
          return new Promise(function (resolve) {
            setTimeout(function () {
              window.location.replace('/')
            }, 2000)
          })
        }).catch((error) => {
          this.showNotice = true
          this.noticeMessage = 'Error resetting password. ' + error.message
        })
    }
  }
}
</script>
